import './ProjectEye.scss';
import { FaEye } from 'react-icons/fa'

const ProjectEye = () => {
  return (
    <div className='project-eye'>
      <FaEye size={40} />
    </div>
  )
}

export default ProjectEye